import { renderColumnNumber } from "../../../Components/DataGrid/ValueCellRender";
import { formatColumnObject } from "../../../Components/DataGrid/ValueFormatter";
import strings from "../../../localization";
import React, {useEffect, useState} from "react";
import {changePageSizeState} from "../../../Slices/PageSlice";
import PageSizeState from "../../../Constants/Base/PageSizeState";
import {useDispatch} from "react-redux";
import TablePage from "../../../Components/DataGrid/TablePage";
import TablePageContext, {
    FilterDefaults,
    TableDataDefaults,
    TablePageOptionDefaults
} from "../../../Context/TablePageContext";
import PageState from "../../../Constants/Base/PageState";
import ReferenceType from "../../../Constants/DocumentManagement/ReferenceType";
import { useNavigate, useSearchParams, useParams } from "react-router-dom";
import { deleteBusinessYearStartValue, getBusinessYearStartValues } from "../../../Services/Finance/BusinessYearStartValueService";
import AddBusinessYearStartValue from "./AddBusinessYearStartValue";
import EditBusinessYearStartValue from "./EditBusinessYearStartValue";
import AppPermissions from "../../../Constants/Permissions/Permissions";
import Modules from "../../../Constants/Base/Modules";
import {changeBreadcrumbs} from "../../../Slices/BreadcrumbsSlice";
import Tag from "../../../Components/Forms/Pages/Document/Tag/Tag";

const tableDescription = [
    {
        field: 'businessYear', headerName: strings.pages.administration.bussinesYearStartValue.bussinesYearStartValueList.businessYear,
        valueFormatter: (params) => formatColumnObject(params, 'year'),
        width: 200
    },
    {
        field: 'bankAccount', headerName: strings.pages.administration.bussinesYearStartValue.bussinesYearStartValueList.bankAccount,
        valueFormatter: (params) => formatColumnObject(params, 'name') ,
        width: 200
    },
    {
        field: 'amount', headerName: strings.pages.administration.bussinesYearStartValue.bussinesYearStartValueList.amount,
        renderCell: (params) => renderColumnNumber(params),
        width: 200
    },
]

const filters = [];

const BusinessYearStartValue = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const {id: businessYear} = useParams();
    const [searchParams, setSearchParams] = useSearchParams();
    const [updatedFilter, setUpdatedFilter] = useState(!Boolean(searchParams.toString()));
    const [columns, setColumns] = useState([]);
    const [pageState, setPageState] = useState(PageState.View);
    const [filter, setFilter] = useState(FilterDefaults);
    const [tableData, setTableData] = useState(TableDataDefaults);
    const [showDeleteDialog, setShowDeleteDialog] = useState(false);
    const [selectionModel, setSelectionModel] = useState([]);
    const [selectedItems, setSelectedItems] = useState(null);
    const [tablePageOptions, setTablePageOptions] = useState(TablePageOptionDefaults);
    const referenceType = ReferenceType.BUSINESS_YEAR_START_VALUE;
    const permissionGroup = AppPermissions.BUSINESS_YEAR_START_VALUE.GROUP;

    const value = {
        tablePageOptions, setTablePageOptions,
        selectionModel, setSelectionModel,
        selectedItems, setSelectedItems,
        filter, setFilter, pageState, setPageState, showDeleteDialog, setShowDeleteDialog,
        navigate, updatedFilter, setUpdatedFilter
    }

    useEffect(() => {
        setColumns([...tableDescription]);
        dispatch(changePageSizeState(PageSizeState.SHORT));
        dispatch(changeBreadcrumbs({
            title: strings.pages.finance.settings.businessYearStartValue.pageTitle,
            hierarchy:[
                {label: strings.navigation.managmentTag},
                {label: Modules.FINANCE},
                {label: strings.pages.finance.settings.settings},
                {label: strings.pages.administration.businessYear.businessYearList.pageTitle},
                {label: strings.pages.finance.settings.businessYearStartValue.pageTitle},
            ],        
        }));

        return () => {
            setTableData({})
        }
    }, [])

    useEffect(() => {
        if(!updatedFilter){
            return;
        }

        fetch();
    }, [filter, updatedFilter]);

    const onCancel = () => {
        setPageState(PageState.View);
    }

    const onFinish = () => {
        fetch();
        setPageState(PageState.View);
    }

    const fetch = () => {
        setTableData({
            ...tableData,
            loading: true
        })

        getBusinessYearStartValues({
            ...filter,
            year: searchParams.get('year'),
        }).then(response => {
            if (!response || !response.ok){
                return;
            }

            setTableData({
                loading: false,
                data: response.data.result,
                total: response.data.total
            });
        })
    }

    return <TablePageContext.Provider value={value}>
        <TablePage onFinish={() => onFinish()} deleteItem={deleteBusinessYearStartValue} tableDescription={columns}
                   tableData={tableData} filter={filter} filters={filters}
                   permissionGroup={permissionGroup}
                   referenceType={referenceType}
                   tagPage={<Tag referenceType={ referenceType } data={ selectedItems } /> }
                   editPage={<EditBusinessYearStartValue data={ selectedItems }
                                                  onCancel={() => onCancel()} onFinish={() => onFinish()}/>}
                   addPage={<AddBusinessYearStartValue businessYear={businessYear} onCancel={() => onCancel()} onFinish={() => onFinish()}/>}
                   addButtonText={strings.components.tablePage.addButton.businessYearStartValue}/>
    </TablePageContext.Provider>;
}

export default BusinessYearStartValue;
